import { sizeToString } from '../lib/string';
import { FileExtension } from './fileTypes';

/** Error messages of the file validations, shared by the client and the server. */
export const FileValidationMessages = {
  missing: 'Missing file',
  multipleFiles: 'Only one file can be uploaded',
  multipleExtensions: 'File name must not contain multiple extensions',
  mimeTypeMismatch: 'File content type does not match its extension',
  contentMismatch: 'File content does not match its extension',
  types: (extensions: FileExtension[]) =>
    `File type must be one of: ${extensions.map(ext => ext.toUpperCase()).join(', ')}`,
  size: (maxBytes: number) => `File must be at most ${sizeToString(maxBytes)}`,
  unknownExtensions: (extensions: string[]) => `Unknown file extension: ${extensions.join(', ')}`,
};
